import { render, staticRenderFns } from "./PeligrosYRiesgos.vue?vue&type=template&id=8574b9ae&scoped=true"
import script from "./PeligrosYRiesgos.vue?vue&type=script&lang=js"
export * from "./PeligrosYRiesgos.vue?vue&type=script&lang=js"
import style0 from "./PeligrosYRiesgos.vue?vue&type=style&index=0&id=8574b9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8574b9ae",
  null
  
)

export default component.exports